module.exports = __webpack_public_path__ + "static/images/styles/images/nations/germany-cn.9f1d72c4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/germany-cn.png
// module id = 3663
// module chunks = 11